import type { SubsectionFieldDescriptor } from '../../../utils/subsectionHeaderMetrics';
import type { RequestFieldDefinition } from '../types';

export function subsectionDescriptorsFromFields(
  fields: readonly RequestFieldDefinition[],
  subsectionId: string,
  surface: 'step' | 'summary' = 'step',
): readonly SubsectionFieldDescriptor[] {
  return fields
    .filter((f) => f.subsectionId === subsectionId && f.surfaces[surface])
    .sort((a, b) => a.order - b.order)
    .map((f) => ({ key: f.dataField, shortLabel: f.shortLabel }));
}

export function subsectionFieldKeys(
  descriptors: readonly SubsectionFieldDescriptor[],
): readonly string[] {
  return descriptors.map((d) => d.key);
}
